<template lang="pug">
div(:class='containerClass')
  .p-product-list(ref='listContent', :class='listClass')
    vue-product-item(v-for='(productId, index) in productsListIds',
      :key='_uid + "_" + index + "_" + productId',
      ref='productItem',
      :product-id='productId',
      :use-vue-lazyload='!isSliderType',
      :target='target',
      :item-classes='itemClasses',
      :item-placeholder-style='itemPlaceholderStyle',
      :thumbnail-size='thumbnailSize',

      :show-wrap-link='showWrapLink',
      :show-body='showBody',
      :show-price='showPrice',
      :show-action='showAction',
      :show-label='showLabel',
      :show-review='showReview',
      :show-rank='showRank',
      :rank='index + ((params.page - 1) * params.limit) + 1',

      :impression-list='impressionList',
      :impression-dimension1='config.impressionDimension1',

      :analytics-category='analyticsCategory',
      :analytics-action='analyticsAction',
      :analytics-label='analyticsLabel',

      :tracking-category='trackingCategory',
      :tracking-action='trackingAction',
      :tracking-label='trackingLabel',
      :tracking-option1='trackingOption1',
      :tracking-option2='trackingOption2',

      @click='onItemClick'
    )
      slot(:product='$store.getters["searchProducts/findById"](productId)', :index='index', :productsListIds='productsListIds')
    .p-product-list__empty(v-if='productsListIds.length === 0')
      p Sorry, there were no matches
</template>

<script>
import productItemOptionsMixin from './productItemOptionsMixin';
import productItemComponent from '../../../components/shop/products/productItem.vue';
import errorConstant from '../../../constants/errors';
import { default as textUtil } from '../../../util/text';
import { default as arrayUtil } from '../../../util/array';

export default {
  props: {
    /*
      List display config
      */
    // 表示タイプ
    type: {
      type: String,
      default: 'cards'
    }, // or slider or list
    // 列数
    columns: {
      type: String,
      default: '5'
    },
    // 追加で指定したいクラス（半角スペースorカンマ区切り）
    classes: {
      type: String
    },

    /*
      API
      */
    api: {
      type: String,
      default: 'search'
    },

    /*
      Search paramerters
      */
    // Product IDs
    productIds: {
      type: String
    },

    // Search keyword
    keyword: {
      type: String
    },
    // Categories
    category: {
      type: String
    },
    // Labels
    label: {
      type: String
    },
    // Brand Name
    brand: {
      type: String
    },
    // Filters
    // lib/util/search:createFilterData
    // discount, free-shipping, in-stock, buyable, premium
    // カンマ区切り
    filters: {
      type: String
    },
    // Low price
    lowPrice: {
      type: String
    },
    // High price
    highPrice: {
      type: String
    },
    // Low point rate
    lowPointRate: {
      type: String
    },
    // High point rate
    highPointRate: {
      type: String
    },
    // Low stock count
    lowStockCount: {
      type: String
    },
    // High stock count
    highStockCount: {
      type: String
    },
    // Sort
    // new, price, -price, rec, wishlist, reviews, rating, restocked
    sort: {
      type: String,
      default: 'new'
    },
    // Page
    page: {
      type: String,
      default: '1'
    },
    // 取得する商品の件数
    limit: {
      type: String,
      default: '20'
    },

    // 表示後すぐに読み込みを実行するかどうか default: true
    immediatelyFetch: {
      type: Boolean,
      default: true
    },

    spType: {
      type: String,
      default: null
    },

    spColumns: {
      type: String,
      default: null
    },

    expectedShipAt: {
      type: Date,
      default: null
    },

    region: {
      type: String,
      default: null
    },

    exclusionIds: {
      type: Array,
      default: null
    }
  },

  mixins: [productItemOptionsMixin],

  data() {
    return {
      config: {},
      params: {},
      productsListIds: [],
      impressedIds: []
    };
  },

  components: {
    'vue-product-item': productItemComponent
  },

  computed: {
    isSliderType() {
      return this.config.type === 'slider';
    },

    isListType() {
      return this.config.type === 'list';
    },

    // スライダーコンテナに使用するクラスオブジェクトを返す
    containerClass() {
      return {
        'p-product-slider__container': this.isSliderType,
        'p-product-slider__container--nobody': this.isSliderType && textUtil.toBoolean(this.showBody)
      };
    },

    // リストコンテナに使用するクラスオブジェクトを返す
    listClass() {
      const cols = this.config.columns;
      const classes = arrayUtil.arrayToClassObject(
        textUtil.stringToArray(this.classes, /\s+|,\s*/)
      );
      return Object.assign(classes, {
        'p-product-list--cards': !this.isListType,
        'p-product-list--col1': cols === 1,
        'p-product-list--col2': cols === 2,
        'p-product-list--col3': cols === 3,
        'p-product-list--col4': cols === 4,
        'p-product-list--col5': cols === 5,
        'p-product-list--col6': cols === 6,
        'p-product-slider__list': this.isSliderType
      });
    },

    setColumns() {
      if (this.columns === 'auto') {
        if (this.$store.state.user.is_smart_phone_device) {
          return '2';
        } else {
          return '5';
        }
      }

      if (this.$store.state.user.is_smart_phone_device && this.spColumns) {
        return this.spColumns;
      }

      return this.columns;
    },

    setImpressionDimension1() {
      if (this.impressionDimension1 === 'auto') {
        if (this.$store.state.user.is_login) {
          return {
            Member: 'Guest'
          };
        }
      }

      return this.impressionDimension1;
    },

    setType() {
      if (this.type === 'auto') {
        if (this.$store.state.user.is_smart_phone_device) {
          return 'slider';
        } else {
          return 'cards';
        }
      }

      if (this.$store.state.user.is_smart_phone_device && this.spType) {
        return this.spType;
      }

      return this.type;
    }
  },

  created() {
    this.config = {
      type: this.setType,
      impressionDimension1: this.setImpressionDimension1,
      columns: parseInt(this.setColumns, 10)
    };

    this.setParams({
      product_ids: this.productIds,
      keyword: this.keyword,
      category: this.category,
      label: this.label,
      brand: this.brand,
      filters: this.filters,
      low_price: this.lowPrice,
      high_price: this.highPrice,
      low_point_rate: this.lowPointRate,
      high_point_rate: this.highPointRate,
      low_stock_count: this.lowStockCount,
      high_stock_count: this.highStockCount,
      sort: this.sort,
      page: this.page,
      limit: this.limit,
      expected_ship_at: this.expectedShipAt,
      region: this.region
    });

    if (this.immediatelyFetch) {
      this.fetch();
    }
  },

  methods: {
    /*
      サーチするパラメータを指定し検索する
      @param {Object} payload - 検索するパラメータ
      */
    setParams(payload) {
      this.params = {
        sort: payload.sort || 'new',
        page: parseInt(payload.page || 1, 10),
        limit: parseInt(payload.limit || 20, 10)
      };

      if (payload.product_ids) {
        this.params.product_ids = textUtil.stringToArray(payload.product_ids);
        if (payload.filters) {
          return (this.params.filters = textUtil
            .stringToArray(payload.filters)
            .toString());
        }
      } else {
        if (payload.keyword) {
          this.params.keyword = payload.keyword.trim();
        }
        if (payload.category) {
          this.params.category = textUtil
            .stringToArray(payload.category)
            .toString();
        }
        if (payload.label) {
          this.params.label = textUtil.stringToArray(payload.label).toString();
        }
        if (payload.brand) {
          this.params.brand = textUtil.stringToArray(payload.brand).toString();
        }
        if (payload.filters) {
          this.params.filters = textUtil
            .stringToArray(payload.filters)
            .toString();
        }
        if (payload.low_price) {
          this.params.low_price = Number(payload.low_price);
        }
        if (payload.high_price) {
          this.params.high_price = Number(payload.high_price);
        }
        if (payload.low_point_rate) {
          this.params.low_point_rate = Number(payload.low_point_rate);
        }
        if (payload.high_point_rate) {
          this.params.high_point_rate = Number(payload.high_point_rate);
        }
        if (payload.low_stock_count) {
          this.params.low_stock_count = parseInt(payload.low_stock_count, 10);
        }
        if (payload.expected_ship_at) {
          if (payload.expected_ship_at instanceof Date) {
            const date = new Date(payload.expected_ship_at);
            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            this.params.expected_ship_at = `${year}-${month}`;
          } else {
            this.params.expected_ship_at = payload.expected_ship_at;
          }
        }
        if (payload.region) {
          this.params.region = payload.region;
        }
      }
    },

    /*
      APIを呼び出す
      @param {Object} payload - 検索するパラメータ
      */
    fetch() {
      let count = 0;
      if (this.config.type === 'slider') {
        count = this.config.columns;
      } else if (
        this.config.type === 'list' &&
        this.params.product_ids &&
        this.params.product_ids.length > 0
      ) {
        count = this.params.product_ids.length;
      } else {
        count = this.params.limit;
      }
      this.productsListIds = Array(count).fill('');

      const action = `searchProducts/${this.api}`;
      return this.$store
        .dispatch(action, this.params)
        .then((res) => {
          this.productsListIds = res.products.map((p) => p._id);

          if (this.exclusionIds && this.exclusionIds.length > 0) {
            this.exclusionIds.forEach((exclusionId) => {
              this.productsListIds = this.productsListIds.filter(item => item !== exclusionId);
            });
          }
          this.$emit('received', res);
          this.received();
        })
        .catch((e) => {
          // API でエラーが起こった際はイベントを送出する
          // TODO: API 仕様が詳しく決まったらエラー処理を実装する
          this.$emit(errorConstant.API_ERROR, e);
          this.productsListIds = [];
        });
    },

    /*
      APIからデータを取得したときに実行される
      Private
      */
    received() {
      if (this.productsListIds.length === 0) {
        this.$emit(errorConstant.EMPTY);
        return;
      }
      this.$nextTick(function() {
        // impression
        // スライダーの場合は初期見えている個数分のみ
        const impressionLast = this.isSliderType ? this.config.columns : -1;
        this.addImpression(0, impressionLast);

        const $list = $(this.$refs.listContent);

        // スライダー
        if (this.isSliderType) {
          let option = {};
          if (this.$store.state.user.is_smart_phone_device) {
            option = {
              // スワイプできることがわかるようアイテムの一部だけ見切れるsetting
              // https://github.com/kenwheeler/slick/issues/973#issuecomment-258861434
              slidesToShow: 2.4,
              slidesToScroll: 2,
              speed: 200,
              arrows: false,
              infinite: false,
              centerMode: false,
              lazyLoad: 'ondemand'
            };
          } else {
            option = {
              slidesToShow: this.config.columns,
              slidesToScroll: this.config.columns,
              infinite: false,
              prevArrow: '<button type="button" class="slick-prev p-product-slider__prev">Previous</button>',
              nextArrow: '<button type="button" class="slick-next p-product-slider__next">Next</button>',
              lazyLoad: 'ondemand'
            };
          }

          // すでに slick 化されていれば unslick する
          if (this.$refs.listContent.slick) {
            $list.slick('unslick');
          }
          $list.slick(option).on('afterChange', (ev, slick, currentSlide) => {
            this.addImpression(
              currentSlide,
              currentSlide + this.config.columns
            );
          });
        }
      });
    },

    /*
      GA に impression を送信する
      refs: tom.helper.ga.list.impression()
      @param {Number} start - impressionを送信する productsListIds の開始インデックス
      @param {Number} last - impressionを送信する productsListIds の終了インデックス
      */
    addImpression(start, last) {
      if (start == null) {
        start = 0;
      }
      if (last == null) {
        last = -1;
      }
      const impressions = [];
      const items = this.$refs.productItem;
      if (last < 0) {
        last = this.productsListIds.length;
      }
      last = Math.min(last, this.productsListIds.length);
      for (
        let i = start, end = last, asc = start <= end; asc ? i < end : i > end; asc ? i++ : i--
      ) {
        if (
          (items[i] != null ? items[i].impression : undefined) != null &&
          this.impressedIds.indexOf(this.productsListIds[i]) < 0
        ) {
          impressions.push(items[i].impression);
          this.impressedIds.push(this.productsListIds[i]);
        }
      }
      if (impressions.length > 0) {
        tom.helper.ga.list.impression(impressions);
      }
    },

    onItemClick(impression) {
      this.$emit('item-click', impression);
    }
  }
};
</script>
